import { useState, useMemo, useCallback } from "react";

const OTBS = [
  { id: "geral-empresa", name: "OTB Geral Empresa", subtitle: "Visão consolidada de todas as categorias e canais", periodo: 2026, canal: "Todos", departamentos: ["Feminino", "Masculino", "Infantil"], categorias: [] },
  { id: "ecommerce", name: "OTB E-commerce", subtitle: "Planejamento exclusivo do canal digital", periodo: 2026, canal: "E-commerce", departamentos: ["Feminino"], categorias: [] },
  { id: "inverno-27", name: "OTB Inverno 27", subtitle: "Planejamento das lojas físicas próprias", periodo: 2026, canal: "Lojas Próprias", departamentos: ["Feminino", "Masculino"], categorias: [] },
];

const MONTHS = ["ABR/25", "MAI/25", "JUN/25", "JUL/25", "AGO/25", "SET/25", "OUT/25"];

const OPEN_EXCESSO_POR_MES = [
  { mes: "Abr/25", aberto: 7156, excesso: -83608 },
  { mes: "Mai/25", aberto: 5324, excesso: -87319 },
  { mes: "Jun/25", aberto: 18576, excesso: -66870 },
  { mes: "Jul/25", aberto: 28069, excesso: -50414 },
  { mes: "Ago/25", aberto: 79050, excesso: -28087 },
  { mes: "Set/25", aberto: 112418, excesso: -21048 },
  { mes: "Out/25", aberto: 213744, excesso: -13936 },
];

const OPEN_BRUTO_POR_CATEGORIA = [
  { categoria: "Acessórios", valores: [-11956, -5102, 3235, 69, 5421, 7568, 27014], total: 26250 },
  { categoria: "Beachwear", valores: [50, 37, 69, 85, 242, 116, 154], total: 753 },
  { categoria: "Blusas", valores: [2961, 1725, 9530, 17886, 39227, 50781, 79620], total: 201729 },
  { categoria: "Calça", valores: [-3933, -14925, -9324, -2588, 13388, 22151, 42275], total: 47043 },
  { categoria: "Macacão", valores: [507, 1035, 1542, 1917, 2688, 2642, 2971], total: 13303 },
  { categoria: "Overtop", valores: [-15763, -9752, -9622, -8443, -6959, -6143, -3158], total: -59840 },
  { categoria: "Regata", valores: [-19154, -20888, -16439, -11395, 3990, 12182, 29779], total: -21925 },
  { categoria: "Saia", valores: [-4907, -9856, -9501, -7559, -3720, -609, 5837], total: -30315 },
  { categoria: "Shorts", valores: [572, -639, -400, 781, 2921, 4186, 7246], total: 14668 },
  { categoria: "Shorts Saia", valores: [982, 687, 1447, 2843, 3166, 2752, 3723], total: 15600 },
  { categoria: "Tricot", valores: [-27895, -26159, -21584, -20430, -17408, -14295, -10778], total: -138549 },
  { categoria: "Vestido", valores: [2084, 1841, 2752, 4488, 8006, 10041, 15126], total: 44338 },
];

const TOTAL_ABERTOS = [7156, 5324, 18576, 28069, 79050, 112418, 213744];
const TOTAL_EXCESSOS = [-83608, -87319, -66870, -50414, -28087, -21048, -13936];

const PERDA_POTENCIAL_MONTHS = ["MAI/25", "JUN/25", "JUL/25", "AGO/25", "SET/25", "OUT/25", "NOV/25"];

const PERDA_POTENCIAL_POR_CATEGORIA = [
  { categoria: "Acessórios", valores: [null, null, 49052, 990, 103373, 141461, 386635], total: 681510 },
  { categoria: "Beachwear", valores: [968, 1070, 777, 667, 881, 924, 1089], total: 6376 },
  { categoria: "Blusas", valores: [152977, 87944, 370747, 722142, 1952671, 2371632, 3949336], total: 9607449 },
  { categoria: "Calça", valores: [null, null, null, 1035339, 1612468, 3181074, null], total: 5828881 },
  { categoria: "Macacão", valores: [59147, 111296, 125528, 161604, 304911, 293094, 327485], total: 1383064 },
  { categoria: "Overtop", valores: [null, null, null, null, null, null, null], total: null },
  { categoria: "Regata", valores: [null, null, null, null, 153429, 440022, 1215715], total: 1809166 },
  { categoria: "Saia", valores: [null, null, null, null, null, null, 603439], total: 603439 },
  { categoria: "Shorts", valores: [28385, null, null, 30104, 160689, 209964, 406222], total: 835364 },
  { categoria: "Shorts Saia", valores: [74129, 54689, 83376, 137497, 294677, 275149, 364493], total: 1284010 },
  { categoria: "Tricot", valores: [null, null, null, null, null, null, null], total: null },
  { categoria: "Vestido", valores: [231207, 209052, 259669, 400900, 928360, 1054422, 1672646], total: 4756257 },
];

const ALL_MONTHS = ["JAN/25", "FEV/25", "MAR/25", "ABR/25", "MAI/25", "JUN/25", "JUL/25", "AGO/25", "SET/25", "OUT/25", "NOV/25", "DEZ/25"];

const PLANO_DATA = {
  faturamento: [16478532, 15139086, 17215850, 11900168, 18835670, 19257656, 13790998, 12280783, 17306996, 15250000, 16800000, 18200000],
  vendaPecas: [75235, 58848, 63208, 39374, 63046, 66798, 54768, 43884, 59247, 51300, 57000, 62000],
  precoOriginal: [309, 310, 321, 329, 329, 336, 334, 330, 323, 320, 318, 315],
  precoVenda: [219, 257, 272, 302, 299, 288, 252, 280, 292, 288, 285, 280],
  markdown: [-29.0, -17.0, -15.0, -8.0, -9.0, -14.0, -25.0, -15.0, -10.0, -8.0, -10.0, -11.0],
  cmvUnitario: [57, 57, 58, 60, 59, 61, 60, 60, 59, 59, 58, 58],
  markupInicial: [5.41, 5.46, 5.48, 5.52, 5.54, 5.53, 5.54, 5.52, 5.50, 5.48, 5.48, 5.47],
  markupFinal: [3.84, 4.53, 4.66, 5.08, 5.03, 4.75, 4.17, 4.69, 4.97, 5.00, 4.90, 4.83],
  lucroBruto: [12182579, 11798095, 13520501, 9555760, 15088114, 15199240, 10486344, 9659745, 13827782, 12227000, 13200000, 14300000],
};

const REALIZADO_DATA = {
  metaVsProj: [-8.0, -10.0, -3.0, null, -13.0, null, null, null, null, null, null, null],
  evolucaoReceita: [39.0, 60.0, 22.0, 18.0, 11.0, 25.0, 13.0, 35.0, 33.0, null, null, null],
  faturamento: [15215468, 13616507, 16642916, 11940468, 16365553, 19257656, 13790998, 12280783, 17306996, null, null, null],
  vendaPecas: [75271, 58865, 63211, 39205, 53959, 66798, 54768, 43884, 59247, null, null, null],
  precoOriginal: [292, 297, 314, 329, 338, 336, 334, 330, 323, null, null, null],
  precoVenda: [202, 231, 263, 305, 303, 288, 252, 280, 292, null, null, null],
  markdownVenda: [-31.0, -22.0, -16.0, -7.0, -10.0, -14.0, -25.0, -15.0, -10.0, null, null, null],
  cmvUnitario: [54, 55, 58, 61, 61, 61, 60, 60, 59, null, null, null],
  markupInicial: [5.42, 5.41, 5.41, 5.43, 5.49, 5.53, 5.54, 5.52, 5.50, null, null, null],
  markupFinal: [3.76, 4.21, 4.55, 5.03, 4.94, 4.75, 4.17, 4.69, 4.97, null, null, null],
  lucroBruto: [11165823, 10381636, 12983021, 9568121, 13050583, 15199240, 10486344, 9659745, 13827782, null, null, null],
  margemBruta: [73.0, 76.0, 78.0, 80.0, 80.0, 79.0, 76.0, 79.0, 80.0, null, null, null],
};

const ESTOQUE_PECAS_DATA = {
  estoqueInicial: [248314, 216677, 233748, 300108, 361798, 382622, 332180, 282486, 238617, 180842, 131120, 75248],
  estoqueCorrente: [null, null, null, null, 371385, null, null, null, null, null, null, null],
  retiradas: [-649, 15000, -39877, 80616, null, null, null, null, null, null, null, null],
  estoqueFinal: [216677, 233748, 300108, 361798, 382622, 332180, 282486, 238617, 180842, 131120, 75248, 27000],
  estoqueIdeal: [339871, 278000, 281146, 234568, 285346, 300627, 283885, 260142, 289580, 272213, 330928, 388000],
  coberturaReal: [3.30, 3.68, 3.70, 7.65, 6.71, 5.73, 6.07, 6.44, 4.03, 3.52, 1.75, null],
  coberturaPlano: [4.52, 4.72, 4.45, 5.96, 4.53, 4.50, 5.18, 5.93, 4.89, 5.30, 4.42, null],
  openToBuy: [61323, 47398, -65540, -76452, -81995, -48294, -22345, 50963, 91371, 199808, 313595, null],
  excessoBruto: [-7384, -14012, -69360, -83608, -87319, -66870, -50414, -28087, -21048, -13936, -6562, null],
  abertoBruto: [68707, 61410, 3819, 7156, 5324, 18576, 28069, 79050, 112418, 213744, 320157, null],
  carteiraReal: [42985, 90936, 89694, 181511, 20951, 16350, 5071, null, null, null, null, null],
};

const ESTOQUE_REAIS_DATA = {
  estoqueInicial: [56686393, 54378407, 64280545, 91345953, 116665119, 116120830, 95987160, 71398610, 67471433, 54571047, 40449206, 19293486],
  carteiraReal: [12897679, 31044086, 32673428, 64049327, 8677965, 5858485, 998403, null, null, null, null, null],
  entradasACusto: [2383900, 5694337, 6011306, 11600136, 1516389, 1516389, 959052, 2940048, 1886838, 5467503, 7349357, null],
  estoqueFinal: [43966883, 53823852, 77797069, 109230781, 116120830, 95987160, 71398610, 67471433, 54571047, 40449206, 19293486, 8429457],
  estoqueIdeal: [79739054, 57865884, 67754097, 63771158, 87084373, 90437431, 79495246, 64216619, 80183165, 79976464, 96170492, 99519303],
  coberturaReal: [3.73, 3.99, 3.86, 7.65, 7.13, 6.03, 6.96, 5.81, 3.90, 3.58, 2.13, 0.53],
  coberturaPlano: [4.52, 4.72, 4.45, 5.96, 4.53, 4.50, 5.18, 5.93, 4.89, 5.30, 4.42, 2.96],
  abertoRS: [3487477, 3473552, -27574794, -29580746, -25683399, -16491914, -7181991, 12711731, 25405417, 55721286, 80225817, null],
};

const DETALHE_CATEGORIAS = [
  "Acessórios", "Beachwear", "Blusas", "Calça", "Macacão",
  "Overtop", "Regata", "Saia", "Shorts", "Shorts Saia", "Tricot", "Vestido",
];

const DETALHE_CATEGORIA_PLANO = {
  faturamento: [464297, 378142, 417171, 239579, 415180, 441678, 336794, 248175, 382879, 344953, 496985, 773711],
  vendaPecas: [4101, 3276, 3768, 2141, 3678, 3903, 3069, 2513, 3771, 3176, 4628, 7404],
  precoOriginal: [120, 120, 118, 115, 117, 117, 117, 117, 117, 117, 117, 117],
  precoVenda: [113, 115, 111, 112, 113, 113, 110, 99, 102, 109, 107, 105],
  markdown: [-5.0, -3.0, -6.0, -3.0, -4.0, -3.0, -6.0, -16.0, -13.0, -7.0, -8.0, -11.0],
  cmvUnitario: [29, 29, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
  markupInicial: [4.09, 4.14, 4.18, 4.16, 4.17, 4.17, 4.16, 4.13, 4.13, 4.15, 4.18, 4.19],
  markupFinal: [3.87, 4.00, 3.91, 4.04, 4.02, 4.03, 3.90, 3.48, 3.59, 3.85, 3.83, 3.74],
  lucroBruto: [344249, 283595, 310612, 180280, 311857, 332111, 250511, 176878, 276103, 255441, 367382, 566957],
};

const DETALHE_CATEGORIA_REALIZADO = {
  metaVsProj: [-16.0, -12.0, -7.0, -6.0, -13.0, null, null, null, null, null, null, null],
  evolucaoReceita: [134.0, 54.0, 11.0, -8.0, 14.0, 43.0, 44.0, -15.0, 3.0, 2.0, 25.0, -20.0],
  faturamento: [389869, 333462, 386677, 225945, 360509, 441678, 336794, 248175, 382879, 344953, 496985, 773711],
  vendaPecas: [4101, 3276, 3768, 2142, 3195, 3903, 3069, 2513, 3771, 3176, 4628, 7404],
  precoOriginal: [110, 112, 113, 114, 121, 117, 117, 117, 117, 117, 117, 117],
  precoVenda: [95, 102, 103, 105, 113, 113, 110, 99, 102, 109, 107, 105],
  markdownVenda: [-14.0, -9.0, -9.0, -8.0, -7.0, -3.0, -6.0, -16.0, -13.0, -7.0, -8.0, -11.0],
  cmvUnitario: [25, 27, 27, 28, 27, 28, 28, 28, 28, 28, 28, 28],
  markupInicial: [4.34, 4.12, 4.17, 4.07, 4.42, 4.17, 4.16, 4.13, 4.13, 4.15, 4.18, 4.19],
  markupFinal: [3.75, 3.73, 3.77, 3.76, 4.13, 4.03, 3.90, 3.48, 3.59, 3.85, 3.83, 3.74],
  lucroBruto: [285921, 243946, 284199, 165803, 273252, 332111, 250511, 176878, 276103, 255441, 367382, 566957],
  margemBruta: [73.3, 72.0, 73.5, 73.4, 75.8, 75.2, 74.4, 71.3, 72.1, 74.1, 73.9, 73.3],
};

const DETALHE_CATEGORIA_ESTOQUE_PECAS = {
  estoqueInicial: [26979, 25865, 23036, 27549, 24084, 21682, 18980, 17171, 14657, 10887, 7710, 3082],
  estoqueCorrente: [null, null, null, null, 22322, null, null, null, null, null, null, null],
  retiradas: [-1182, 1453, -8281, 14073, null, null, null, null, null, null, null, null],
  estoqueFinal: [25865, 23036, 27549, 24084, 21682, 18980, 17171, 14657, 10887, 7710, 3082, null],
  estoqueIdeal: [40407, 18590, 12159, 6924, 12128, 16581, 22215, 17239, 20078, 18454, 34725, 17530],
  coberturaReal: [6.58, 7.90, 6.11, 12.86, 7.54, 5.56, 6.18, 6.83, 3.89, 3.43, 1.67, null],
  coberturaPlano: [9.85, 5.67, 3.23, 3.23, 3.30, 4.25, 7.24, 6.86, 5.32, 5.81, 7.50, 2.37],
  openToBuy: [-7275, -10877, -20625, -11956, -5102, 3235, 69, 5421, 7568, 27014, 14448, null],
  excessoBruto: [null, null, null, null, null, null, null, null, null, null, null, null],
  abertoBruto: [null, null, null, null, null, null, null, null, null, null, null, null],
  carteiraReal: [1805, 1900, null, 12750, null, 1200, 1260, null, null, null, null, null],
};

const DETALHE_CATEGORIA_ESTOQUE_REAIS = {
  estoqueInicial: [2625418, 2750589, 2450351, 2782784, 2316531, 2446865, 2147921, 1884262, 1447356, 1105398, 837343, 330978],
  carteiraReal: [324670, 311920, null, 1159273, null, 119880, 125874, null, null, null, null, null],
  entradasACusto: [78881, 74832, null, 262042, null, 124697, 35744, 151554, 60506, 544572, null, null],
  estoqueFinal: [2458902, 2344822, 2827112, 2540452, 2446865, 2147921, 1884262, 1447356, 1105398, 837343, 330978, null],
  estoqueIdeal: [3832311, 1767337, 1237609, 710519, 1279348, 1871155, 2514078, 1891809, 1982649, 1873831, 3771148, 1882432],
  coberturaReal: [6.73, 8.25, 6.34, 12.32, 6.43, 5.54, 6.38, 7.59, 3.78, 3.20, 1.68, 0.43],
  coberturaPlano: [9.85, 5.67, 3.23, 3.23, 3.30, 4.25, 7.24, 6.86, 5.32, 5.81, 7.50, 2.37],
  abertoRS: [-983252, -1212742, -2072265, -1037183, -575710, 366157, 7547, 535294, 768433, 2933806, 1551454, null],
};

const PERFORMANCE_PERIODS = ["Ano Atual", "YTD", "Mês passado"];

const PERFORMANCE_KPIS = {
  "YTD": { fatPlano: 18800000, fatReal: 16400000, fatRealDiff: -13.1, lucroBruto: 13100000, fatLY: 14800000, fatLYDiff: -9.7 },
  "Ano Atual": { fatPlano: 22000000, fatReal: 19200000, fatRealDiff: -12.7, lucroBruto: 15400000, fatLY: 17500000, fatLYDiff: 9.7 },
  "Mês passado": { fatPlano: 19257656, fatReal: 16365553, fatRealDiff: -15.0, lucroBruto: 13050583, fatLY: 14900000, fatLYDiff: 9.8 },
};

const PERFORMANCE_CATEGORIAS = [
  { categoria: "ACESSORIOS", fatPlano: 415180, fatReal: 361000, fatLY: 315000, fatVsLY: 14.0, fatDif: 45000, isPositive: true, vendaPlano: 3678, vendaReal: 3195, vendaLY: 3192, vendaPct: 0.0, vendaPos: true, pmPlano: 113, pmReal: 113, pmLY: 99, mkPlano: 4.02, mkReal: 4.13, mkLY: 3.39, estoqueReal: 24084, estoqueLY: 10814, estoquePct: 123.0, estoquePos: true, cobReal: 7.5, cobLY: 3.4, cobPct: 123.0, cobPos: true },
  { categoria: "BEACHWEAR", fatPlano: 987, fatReal: -31, fatLY: 876, fatVsLY: 104.0, fatDif: -907, isPositive: false, vendaPlano: 5, vendaReal: 0, vendaLY: 6, vendaPct: 100.0, vendaPos: false, pmPlano: 198, pmReal: 0, pmLY: 146, mkPlano: 2.59, mkReal: 0.00, mkLY: 2.61, estoqueReal: 1, estoqueLY: 62, estoquePct: 98.0, estoquePos: false, cobReal: 1.0, cobLY: 10.3, cobPct: 98.0, cobPos: false },
  { categoria: "BLUSAS", fatPlano: 4100000, fatReal: 2900000, fatLY: 3600000, fatVsLY: 18.0, fatDif: -640000, isPositive: false, vendaPlano: 17534, vendaReal: 12680, vendaLY: 17795, vendaPct: 29.0, vendaPos: false, pmPlano: 235, pmReal: 232, pmLY: 201, mkPlano: 5.03, mkReal: 4.90, mkLY: 4.83, estoqueReal: 76679, estoqueLY: 70136, estoquePct: 9.0, estoquePos: true, cobReal: 6.0, cobLY: 3.9, cobPct: 9.0, cobPos: true },
  { categoria: "CALCA", fatPlano: 5000000, fatReal: 4300000, fatLY: 3700000, fatVsLY: 17.0, fatDif: 631000, isPositive: true, vendaPlano: 12582, vendaReal: 10842, vendaLY: 10255, vendaPct: 6.0, vendaPos: true, pmPlano: 399, pmReal: 401, pmLY: 363, mkPlano: 5.32, mkReal: 5.11, mkLY: 4.85, estoqueReal: 68464, estoqueLY: 52520, estoquePct: 30.0, estoquePos: true, cobReal: 6.3, cobLY: 5.1, cobPct: 30.0, cobPos: true },
  { categoria: "MACACAO", fatPlano: 327000, fatReal: 251000, fatLY: 202000, fatVsLY: 24.0, fatDif: 49000, isPositive: true, vendaPlano: 710, vendaReal: 518, vendaLY: 488, vendaPct: 6.0, vendaPos: true, pmPlano: 460, pmReal: 485, pmLY: 414, mkPlano: 4.42, mkReal: 4.38, mkLY: 4.35, estoqueReal: 2296, estoqueLY: 2154, estoquePct: 7.0, estoquePos: true, cobReal: 4.4, cobLY: 4.4, cobPct: 7.0, cobPos: true },
  { categoria: "OVERTOP", fatPlano: 873000, fatReal: 1600000, fatLY: 937000, fatVsLY: 73.0, fatDif: 680000, isPositive: true, vendaPlano: 1876, vendaReal: 3513, vendaLY: 2438, vendaPct: 44.0, vendaPos: true, pmPlano: 465, pmReal: 460, pmLY: 384, mkPlano: 4.84, mkReal: 4.90, mkLY: 4.57, estoqueReal: 25411, estoqueLY: 9958, estoquePct: 155.0, estoquePos: true, cobReal: 7.2, cobLY: 4.1, cobPct: 155.0, cobPos: true },
  { categoria: "REGATA", fatPlano: 1700000, fatReal: 1600000, fatLY: 1700000, fatVsLY: 9.0, fatDif: -155000, isPositive: false, vendaPlano: 9006, vendaReal: 8043, vendaLY: 10056, vendaPct: 20.0, vendaPos: false, pmPlano: 194, pmReal: 194, pmLY: 170, mkPlano: 4.89, mkReal: 4.89, mkLY: 4.75, estoqueReal: 70139, estoqueLY: 34028, estoquePct: 106.0, estoquePos: true, cobReal: 8.7, cobLY: 3.4, cobPct: 106.0, cobPos: true },
  { categoria: "SAIA", fatPlano: 1300000, fatReal: 1000000, fatLY: 1500000, fatVsLY: 34.0, fatDif: -509000, isPositive: false, vendaPlano: 3138, vendaReal: 2618, vendaLY: 4226, vendaPct: 38.0, vendaPos: false, pmPlano: 418, pmReal: 384, pmLY: 358, mkPlano: 4.92, mkReal: 4.55, mkLY: 4.69, estoqueReal: 17900, estoqueLY: 18195, estoquePct: 2.0, estoquePos: false, cobReal: 6.8, cobLY: 4.3, cobPct: 2.0, cobPos: false },
  { categoria: "SHORTS", fatPlano: 447000, fatReal: 331000, fatLY: 580000, fatVsLY: 43.0, fatDif: -249000, isPositive: false, vendaPlano: 1602, vendaReal: 1186, vendaLY: 2369, vendaPct: 50.0, vendaPos: false, pmPlano: 279, pmReal: 279, pmLY: 245, mkPlano: 4.60, mkReal: 4.82, mkLY: 4.39, estoqueReal: 8429, estoqueLY: 11775, estoquePct: 28.0, estoquePos: false, cobReal: 7.1, cobLY: 5.0, cobPct: 28.0, cobPos: false },
  { categoria: "SHORTS SAIA", fatPlano: 318000, fatReal: 133000, fatLY: 442000, fatVsLY: 70.0, fatDif: -310000, isPositive: false, vendaPlano: 1001, vendaReal: 428, vendaLY: 1462, vendaPct: 71.0, vendaPos: false, pmPlano: 317, pmReal: 310, pmLY: 303, mkPlano: 5.13, mkReal: 5.02, mkLY: 4.74, estoqueReal: 3224, estoqueLY: 6086, estoquePct: 47.0, estoquePos: false, cobReal: 7.5, cobLY: 4.2, cobPct: 47.0, cobPos: false },
  { categoria: "TRICOT", fatPlano: 2800000, fatReal: 3100000, fatLY: 852000, fatVsLY: 263.0, fatDif: 2200000, isPositive: true, vendaPlano: 9003, vendaReal: 9398, vendaLY: 3544, vendaPct: 165.0, vendaPos: true, pmPlano: 310, pmReal: 329, pmLY: 241, mkPlano: 5.35, mkReal: 5.36, mkLY: 5.49, estoqueReal: 54087, estoqueLY: 4746, estoquePct: 1040.0, estoquePos: true, cobReal: 5.8, cobLY: 1.3, cobPct: 1040.0, cobPos: true },
  { categoria: "VESTIDO", fatPlano: 1500000, fatReal: 730000, fatLY: 922000, fatVsLY: 21.0, fatDif: -192000, isPositive: false, vendaPlano: 2909, vendaReal: 1538, vendaLY: 2457, vendaPct: 37.0, vendaPos: false, pmPlano: 502, pmReal: 475, pmLY: 375, mkPlano: 4.53, mkReal: 4.08, mkLY: 4.36, estoqueReal: 11084, estoqueLY: 12686, estoquePct: 13.0, estoquePos: false, cobReal: 7.2, cobLY: 5.2, cobPct: 13.0, cobPos: false },
];

const SETUP_DEFAULT = {
  periodo: "2025",
  canalVenda: "Varejo - Lojas Físicas",
  departamento: "Feminino",
  metaFaturamento: "5.500.000",
  leadTimes: [
    { categoria: "Blusa Manga Curta", dias: 120 },
    { categoria: "Blusa Básica", dias: 90 },
    { categoria: "Regata", dias: 90 },
    { categoria: "Top", dias: 90 },
    { categoria: "Camiseta", dias: 90 },
    { categoria: "Bermuda", dias: 120 },
    { categoria: "Calça", dias: 150 },
    { categoria: "Vestido", dias: 120 },
    { categoria: "Saia", dias: 120 },
    { categoria: "Jaqueta", dias: 180 },
  ],
};

const NOVO_OTB_CATEGORIAS = [
  "Acessórios", "Beachwear", "Blusas", "Calça",
  "Calçados", "Camisa", "Camiseta", "Jaqueta",
  "Moletom", "Polo", "Regata", "Saia",
  "Shorts", "Shorts Saia", "Tricot", "Vestido",
];

const CANAIS = ["Todos", "Lojas Próprias", "E-commerce", "Multimarcas", "Franquias"];
const PERIODOS = ["2026", "2027"];
const DEPARTAMENTOS = ["Feminino", "Masculino", "Infantil"];

export const useOtbPlanningViewModel = () => {
  const [activeView, setActiveView] = useState("openVsExcessos");
  const [selectedOtbId, setSelectedOtbId] = useState("geral-empresa");
  const [otbSidebarOpen, setOtbSidebarOpen] = useState(true);
  const [activeOtbTab, setActiveOtbTab] = useState("plano");
  const [activeDetalheTab, setActiveDetalheTab] = useState("plano");
  const [selectedCategory, setSelectedCategory] = useState("Acessórios");
  const [performancePeriod, setPerformancePeriod] = useState("YTD");
  const [showNovoOtbModal, setShowNovoOtbModal] = useState(false);
  const [novoOtbForm, setNovoOtbForm] = useState({
    nome: "", canal: "Todos", periodo: "2026", departamentos: [], categorias: [],
  });
  const [otbs, setOtbs] = useState(OTBS);
  const [setup, setSetup] = useState(SETUP_DEFAULT);
  const [setupSaved, setSetupSaved] = useState(false);

  const selectedOtb = useMemo(
    () => otbs.find((o) => o.id === selectedOtbId) || otbs[0],
    [otbs, selectedOtbId]
  );

  const performanceKpis = useMemo(
    () => PERFORMANCE_KPIS[performancePeriod] || PERFORMANCE_KPIS["YTD"],
    [performancePeriod]
  );

  const openBrutoTotal = useMemo(
    () => TOTAL_ABERTOS.reduce((s, v) => s + v, 0),
    []
  );

  const excessoBrutoTotal = useMemo(
    () => Math.abs(TOTAL_EXCESSOS.reduce((s, v) => s + v, 0)),
    []
  );

  const perdaPotencialTotal = useMemo(
    () => PERDA_POTENCIAL_POR_CATEGORIA.reduce((s, r) => s + (r.total || 0), 0),
    []
  );

  const otbSubtitle = useMemo(() => {
    if (!selectedOtb) return "";
    return `${selectedOtb.subtitle || "Visão consolidada de todas as categorias e canais"} · ${selectedOtb.periodo} · ${selectedOtb.canal}`;
  }, [selectedOtb]);

  const availableCategories = useMemo(
    () => selectedOtb?.categorias?.length > 0 ? selectedOtb.categorias : DETALHE_CATEGORIAS,
    [selectedOtb]
  );

  const displayCategory = useMemo(
    () => availableCategories.includes(selectedCategory) ? selectedCategory : availableCategories[0] || selectedCategory,
    [availableCategories, selectedCategory]
  );

  const handleSetActiveView = useCallback((view) => setActiveView(view), []);

  const handleSelectOtb = useCallback((id) => {
    setSelectedOtbId(id);
    setActiveView("otbDetalhado");
  }, []);

  const handleSetSelectedOtbOnly = useCallback((id) => {
    setSelectedOtbId(id);
  }, []);

  const handleToggleOtbSidebar = useCallback(() => setOtbSidebarOpen((p) => !p), []);

  const handleSetActiveOtbTab = useCallback((tab) => setActiveOtbTab(tab), []);

  const handleSetActiveDetalheTab = useCallback((tab) => setActiveDetalheTab(tab), []);

  const handleSetSelectedCategory = useCallback((cat) => setSelectedCategory(cat), []);

  const handleSetPerformancePeriod = useCallback((p) => setPerformancePeriod(p), []);

  const handleOpenNovoOtbModal = useCallback(() => setShowNovoOtbModal(true), []);

  const handleCloseNovoOtbModal = useCallback(() => {
    setShowNovoOtbModal(false);
    setNovoOtbForm({ nome: "", canal: "Todos", periodo: "2026", departamentos: [], categorias: [] });
  }, []);

  const handleUpdateNovoOtbForm = useCallback((field, value) => {
    setNovoOtbForm((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleCriarOtb = useCallback(() => {
    if (!novoOtbForm.nome.trim()) return;
    const newOtb = {
      id: novoOtbForm.nome.toLowerCase().replace(/\s+/g, "-") + "-" + Date.now(),
      name: novoOtbForm.nome,
      periodo: parseInt(novoOtbForm.periodo, 10),
      canal: novoOtbForm.canal,
      departamentos: novoOtbForm.departamentos,
      categorias: novoOtbForm.categorias,
    };
    setOtbs((prev) => [...prev, newOtb]);
    setSelectedOtbId(newOtb.id);
    setActiveView("otbDetalhado");
    handleCloseNovoOtbModal();
  }, [novoOtbForm, handleCloseNovoOtbModal]);

  const handleUpdateSetup = useCallback((field, value) => {
    setSetup((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleUpdateLeadTime = useCallback((index, dias) => {
    setSetup((prev) => ({
      ...prev,
      leadTimes: prev.leadTimes.map((lt, i) => i === index ? { ...lt, dias } : lt),
    }));
  }, []);

  const handleDeleteLeadTime = useCallback((index) => {
    setSetup((prev) => ({
      ...prev,
      leadTimes: prev.leadTimes.filter((_, i) => i !== index),
    }));
  }, []);

  const handleAddLeadTime = useCallback(() => {
    setSetup((prev) => ({
      ...prev,
      leadTimes: [...prev.leadTimes, { categoria: "Nova Categoria", dias: 90 }],
    }));
  }, []);

  const handleSalvarSetup = useCallback(() => {
    setSetupSaved(true);
    setTimeout(() => setSetupSaved(false), 3000);
  }, []);

  return {
    actions: {
      setActiveView: handleSetActiveView,
      selectOtb: handleSelectOtb,
      setSelectedOtbOnly: handleSetSelectedOtbOnly,
      toggleOtbSidebar: handleToggleOtbSidebar,
      setActiveOtbTab: handleSetActiveOtbTab,
      setActiveDetalheTab: handleSetActiveDetalheTab,
      setSelectedCategory: handleSetSelectedCategory,
      setPerformancePeriod: handleSetPerformancePeriod,
      openNovoOtbModal: handleOpenNovoOtbModal,
      closeNovoOtbModal: handleCloseNovoOtbModal,
      updateNovoOtbForm: handleUpdateNovoOtbForm,
      criarOtb: handleCriarOtb,
      updateSetup: handleUpdateSetup,
      updateLeadTime: handleUpdateLeadTime,
      deleteLeadTime: handleDeleteLeadTime,
      addLeadTime: handleAddLeadTime,
      salvarSetup: handleSalvarSetup,
    },
    ctx: {
      otbs,
      selectedOtb,
      otbSubtitle,
      availableCategories,
      displayCategory,
      openBrutoTotal,
      excessoBrutoTotal,
      perdaPotencialTotal,
      months: MONTHS,
      openExcessoPorMes: OPEN_EXCESSO_POR_MES,
      openBrutoPorCategoria: OPEN_BRUTO_POR_CATEGORIA,
      totalAbertos: TOTAL_ABERTOS,
      totalExcessos: TOTAL_EXCESSOS,
      perdaPotencialMonths: PERDA_POTENCIAL_MONTHS,
      perdaPotencialPorCategoria: PERDA_POTENCIAL_POR_CATEGORIA,
      allMonths: ALL_MONTHS,
      planoData: PLANO_DATA,
      realizadoData: REALIZADO_DATA,
      estoquePecasData: ESTOQUE_PECAS_DATA,
      estoqueReaisData: ESTOQUE_REAIS_DATA,
      detalheCategorias: DETALHE_CATEGORIAS,
      detalheCategoriaPlano: DETALHE_CATEGORIA_PLANO,
      detalheCategoriaRealizado: DETALHE_CATEGORIA_REALIZADO,
      detalheCategoriaEstoquePecas: DETALHE_CATEGORIA_ESTOQUE_PECAS,
      detalheCategoriaEstoqueReais: DETALHE_CATEGORIA_ESTOQUE_REAIS,
      performancePeriods: PERFORMANCE_PERIODS,
      performanceKpis,
      performanceCategorias: PERFORMANCE_CATEGORIAS,
      canais: CANAIS,
      periodos: PERIODOS,
      departamentos: DEPARTAMENTOS,
      novoOtbCategorias: NOVO_OTB_CATEGORIAS,
      novoOtbForm,
      setup,
    },
    uiState: {
      activeView,
      selectedOtbId,
      otbSidebarOpen,
      activeOtbTab,
      activeDetalheTab,
      selectedCategory,
      performancePeriod,
      showNovoOtbModal,
      setupSaved,
    },
  };
};
